import React from 'react'
import Logo from "../../assets/images/logo.png"
import "../ErrorPage/Error.css"

const Error = () => {
  return (
    <div className='page-top'>
    <div className="errorPage">
      <div className="errorPage_container">
        <div className="d-logo">
          <a href="index.html"><img src={Logo} alt="logo" width="80" /></a>
        </div>
        <h2>404</h2>
        <h1>Page Not Found</h1>
        <p>Sorry, we can't find the page you're looking for.</p>
        {/* <a href="/">
              <i className="fa-solid fa-arrow-left-long"></i> &nbsp;Back to
              Login
            </a> */}
        <a href="/" className="btn_back btn btn-primary">Back to Home</a>
      </div>
    </div>
    </div>
  )
}

export default Error